import { Button } from 'components/common'
import SearchBar from 'components/common/dataTable/searchBar'
import { PlusIcon } from 'components/icons'
import UsersTable from 'components/userManagement/usersTable'
import { usePageAccess } from 'hooks'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import { PAGE_ADD_USER } from 'utils/constants'

const UserManagement = () => {
  const navigate = useNavigate()

  const { isEditor } = usePageAccess()

  return (
    <>
      <Helmet>
        <title>ORMS User Management </title>
      </Helmet>

      {isEditor && (
        <Button
          buttonText="Create New User"
          icon={<PlusIcon />}
          className="mb-5"
          onClick={() => navigate(PAGE_ADD_USER.path)}
        />
      )}

      <div className="mb-2 flex flex-wrap items-center justify-between md:mb-0  md:flex-nowrap">
        <h3 className="title">Current Users</h3>
        <SearchBar placeholder="Search by email, name and employee ID" />
      </div>

      <UsersTable isEditor={isEditor} />
    </>
  )
}

export default UserManagement
